import React from 'react';
import {
  OutlinedInput,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material/';
import { useFetchNoUser } from '../hooks/useFetchNoUser';
function SelectPreviousGrade({ prevGrade, setPrevGrade, disabled }) {
  const { error, isPending, data } = useFetchNoUser(
    'https://pcapi.bi-oss.co.za/shared/gradesall',
  );
  return (
    <FormControl fullWidth>
      <InputLabel id="prevGradeLabel">Select Current Grade*</InputLabel>
      <Select
        labelId="prevGradeLabel"
        id="prevGrade"
        value={prevGrade}
        label="Select Previous Grade*"
        onChange={(e) => setPrevGrade(e.target.value)}
        required
        disabled={disabled}
      >
        {data &&
          data.map((data) => (
            <MenuItem key={data.id} value={data.id}>
              {data.LevelGrade}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}

export default SelectPreviousGrade;
